import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { PracticeReseveContext } from '../../PracticeReseveContext';
import Modal from '../../../../common/Modal';
import PracticeReserveSelectInstructorSelect from './select/PracticeReserveSelectInstructorSelect';
import PracticeReserveSelectInstructorModal from './modal/PracticeReserveSelectInstructorModal';
import PracticeReserveSelectInstructorRequest from './modal/request/PracticeReserveSelectInstructorRequest';

import { PracticeReserveInstructorModel } from '../../../../../models/practice/reserve/instructor/PracticeReserveInstructor';


// 講師選択
function PracticeReserveSelectInstructor() {

  const isPc = useContext(cmnContext).isPc;
  const {
    isLoading,
    instId,
    instructors, setInstructors,
  } = useContext(PracticeReseveContext);

  const [selectInst, setSelectInst] = useState<PracticeReserveInstructorModel | null>(null);
  // 講師未選択画像
  const noSelectImg = '/images/page/lesson/live/noselect_inst.png';
  // 日本語可能な講師(ランダム)
  const jaRandomInstructor = {
    inst_id: 'ja',
    name: '日本語可能な講師(ランダム)',
    image_file: '/images/page/practice/noimage_random.png',
    schedule_count: 0,
    open_term_flg: {
      term_15: true,
      term_30: true,
      term_45: true
    },
    gender: '',
    hometown: '',
    is_ja: '',
    hobby: '',
  } as PracticeReserveInstructorModel;
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);
  const [isDispRequest, setIsDispRequest] = useState<boolean>(false);


  // 講師一覧に日本語可能なランダムデータ追加
  useEffect(() => {
    // 日本語可能な講師(ランダム)があるか判定
    const exists = instructors.some((inst: PracticeReserveInstructorModel) => inst.inst_id === jaRandomInstructor.inst_id);
    if(!exists) {
      setInstructors([jaRandomInstructor, ...instructors]);
    }
  }, [instructors])


  // 選択講師情報
  useEffect(() => {
    const newSltInst = instructors.find((inst: any) => inst.inst_id === instId);
    setSelectInst(newSltInst);
  }, [isLoading, instId])


  // 講師情報から画像取得
  function getInstImg(inst: PracticeReserveInstructorModel) {
    // (API処理)設定されていてもサーバ上に画像ファイルがなければデフォルト
    let imgSrc = '';
    if(inst.inst_id == jaRandomInstructor.inst_id) {
      // 日本語可能な講師(ランダム)
      imgSrc = jaRandomInstructor.image_file;
    } else {
      if(inst.image_file) {
        // 画像設定
        const now = new Date();
        const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
        imgSrc = `/images/instructor/${inst.image_file}?${yearMonth}`;
      } else if(inst.gender == '1') {
        // 男性
        imgSrc = '/images/page/lesson/live/noimage_male.png';
      } else {
        // 女性
        imgSrc = '/images/page/lesson/live/noimage_female.png';
      }
    }
    return imgSrc;
  }


  // 講師情報(日本語可/出身地)
  const getInstInfo = ((inst: PracticeReserveInstructorModel) => {
    let newInstInfo = '';
    if(inst) {
      // 講師情報: 日本語可
      if(inst.is_ja === '1') {
        newInstInfo = '日本語可';
      } else if(inst.is_ja === '3') {
        newInstInfo = '日本語聞き取れる';
      } else {
        newInstInfo = '';
      }
      // 講師情報: 出身地
      if(inst.hometown) {
        newInstInfo = newInstInfo
          ? newInstInfo + ' / ' + inst.hometown + '出身'
          : inst.hometown + '出身';
      }
    }
    return newInstInfo;
  });


  return (
    <div style={{marginBottom: '10px'}}>

      <label
        className="control-label"
        htmlFor="InputSelect"
        style={{
          marginTop: '10px',
          backgroundColor: '#eaf3ff',
          padding: '0.25em 3em 0.25em 0.5em',
          borderLeft: 'solid 5px #516ab6',
        }}
      >
        セッションする外国人講師
      </label>

      <div>
        <input type="hidden" name="inst_id" value={instId} />

        {/* 選択講師 */}
        <PracticeReserveSelectInstructorSelect
          setIsDispModal={setIsDispModal}
          selectInst={selectInst}
          noSelectImg={noSelectImg}
          jaRandomInstructor={jaRandomInstructor}
          getInstImg={getInstImg}
          getInstInfo={getInstInfo}
        />

        {/* 選択モーダル */}
        <Modal
          comp={
            <PracticeReserveSelectInstructorModal
              selectInst={selectInst}
              setIsDispModal={setIsDispModal}
              setIsDispRequest={setIsDispRequest}
              jaRandomInstructor={jaRandomInstructor}
              getInstImg={getInstImg}
              getInstInfo={getInstInfo}
            />
          }
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          modalWidth={isPc? '60%' : '95%'}
        />

        {/* 講師リクエストモーダル */}
        <Modal
          comp={
            <PracticeReserveSelectInstructorRequest
              setIsDispModal={setIsDispRequest}
            />
          }
          isDispModal={isDispRequest}
          setIsDispModal={setIsDispRequest}
          modalWidth={isPc? '60%' : '95%'}
          modalMaxHeight={isPc? '85vh' : '85vh'}
          isDispClose={true}
          isBackClose={false}
        />
      </div>

    </div>
  );
}
  
export default PracticeReserveSelectInstructor;